var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('h1',[_vm._v("404: Page not found.")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n    Home\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }